// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"687c5d7d","455":"e13be391"}[chunkId] + ".chunk.js";
};